import sanitizeHtml from 'sanitize-html';

import { SANITIZE_ALLOWED_LINK_ATTRIBUTES, SANITIZE_ALLOWED_TAGS } from './sanitizeOptions';

export const sanitize = (html: string): string =>
  sanitizeHtml(html, {
    allowedTags: SANITIZE_ALLOWED_TAGS,
    allowedAttributes: { a: SANITIZE_ALLOWED_LINK_ATTRIBUTES },
  });
